export const VisiblityIconStyles = {
  position: "absolute",
  right: "30px",
};

export const VisiblityStyle = { color: "rgba(0,0,0,0.3)" };
